<script setup lang="ts">
import { TeamSide } from '@collector/shared-domain'
import { Incident } from '@collector/sportsapi-client'

import DisplayInfo from './DisplayInfo.vue'
import IncidentAttributesSelect from './IncidentAttributesSelect.vue'
import IncidentPlayers from './IncidentPlayers/IncidentPlayers.vue'
import { useHistoryIncidentSettings } from './useHistoryIncidentSettings'

interface Props {
  incident: Incident
  disabled: boolean
  teamSide: TeamSide | null
}

const props = defineProps<Props>()

const {
  attributeIds,
  attributesSelectionConstraint,
  singleAttributes,
  displayInfo,
} = useHistoryIncidentSettings(props.incident)
</script>

<template>
  <IncidentPlayers
    :disabled
    :incident
    :teamSide
  />
  <IncidentAttributesSelect
    v-if="attributeIds"
    :attributeIds
    :disabled
    :incident
    :singleAttributes
    :attributesSelectionConstraint
  />
  <DisplayInfo
    v-if="displayInfo !== undefined"
    :incident
    :displayInfo
    :disabled
  />
</template>
